import { render, staticRenderFns } from "./ShoppingCartResume.vue?vue&type=template&id=559232d4&scoped=true"
import script from "./ShoppingCartResume.vue?vue&type=script&lang=js"
export * from "./ShoppingCartResume.vue?vue&type=script&lang=js"
import style0 from "./ShoppingCartResume.vue?vue&type=style&index=0&id=559232d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559232d4",
  null
  
)

export default component.exports